import router from '@kurotetsu/public/routes';
import React from 'react';
import { RouterProvider } from 'react-router-dom';

const App: React.FC = () => <RouterProvider router={router} />;

export default App;
